import axios from "axios";
import {EventBus} from "../../../shared/utilities/event-bus";
import AuthService from "@/packages/auth/authService";

export default {
    namespaced: true,
    state: {

    },
    mutations: {
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },
    getters: {
        SimulatorGetter: (state) => (setup) => state[setup],
    },
    actions: {
        /**
         *
         * @param commit
         * @param payload
         * @returns {Promise<*>}
         */
        getAccessToken: async ({commit},payload) => {
            commit('Dashboard/SET_LOADING', true, { root: true })
            axios.get("https://sandbox.sasapay.app/api/v1/auth/token/?grant_type=client_credentials", {
                headers: {
                    "Authorization": "Basic "+payload.authorization,
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                withCredentials:true,
                credentials: 'same-origin',
                crossdomain: true,
                mode: 'no-cors',
                roxy: {
                    host: "http://localhost",
                    port: 8080
                }
            })
                .then(res => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    if (res.data.status) {
                        EventBus.$emit("ApiSuccess", res.data.detail);
                        //
                        AuthService.login(res.data)
                        setTimeout(()=>{
                            window.location.href="/dashboard/applications"
                        },1500)

                    } else{
                        EventBus.$emit("ApiError",res.data.detail);
                    }
                })
                .catch( (err) => {
                    commit('Dashboard/SET_LOADING', false, { root: true })
                    EventBus.$emit('submitting',false)
                    EventBus.$emit("ApiError",err?.response?.data?.message || 'Something went wrong');
                });
        },
        generateToken: async ({commit},payload) => {
            commit('Dashboard/SET_LOADING', true, { root: true })
            new Promise((resolve,reject) => {
                const config = {
                    method: 'get',
                    url: "https://sandbox.sasapay.app/api/v1/auth/token/?grant_type=client_credentials",
                    headers: {
                        "Authorization": "Basic "+payload.authorization,
                        'Content-Type': 'application/json'
                    },
                };
                axios(config)
                    .then(function (resp) {
                        commit('Dashboard/SET_LOADING', false, { root: true })
                        const results = resp.data;
                        if (!results.token || results.token === 'None') {
                            return reject(results.description);
                        }
                        return resolve(results)
                    })
                    .catch(function (error) {
                        commit('Dashboard/SET_LOADING', false, { root: true })
                        return reject(error);
                    });
            });
        }

    }
}
